import React from 'react'
import ReactDOM from 'react-dom'

import client from './common'
import CartPopup from './components/cartPopup'

const rootEl = document.getElementById('react-cart-popup')

rootEl && ReactDOM.render(<CartPopup client={client} />, rootEl)
